import { useCallback, useEffect, useRef, useState } from "react";
import is from "@sindresorhus/is";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";

import ImagePlaceholder from "../ImagePlaceholder/ImagePlaceholder";
import Heading from "../Heading/Heading";
import Popup from "../Popup/Popup";

import actions from "../../../data/actions";

const WhoWeAre = props => {
  const theme = useTheme();

  const [currentPost, setCurrentPost] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [posts, setPosts] = useState();

  const bgcolor = theme.palette.background.paperAlt;
  const color = theme.palette.getContrastText(bgcolor);

  const popupOnClose = useCallback(() => setPopupOpen(false), []);
  const postOnClick = useCallback(post => {
    setCurrentPost(post);
    setPopupOpen(true);
  }, []);

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  // (init) -> posts
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getWhoWeArePosts())
      .then(posts => setPosts(posts))
      .catch(error => console.log(error));
  }, []);

  return (
    <>
      {is.nonEmptyArray(posts) && (
        <>
          <Paper elevation={0} square sx={{ bgcolor, color }}>
            <Container disableGutters maxWidth="lg">
              <Heading label={"Kik vagyunk?"} sx={{ py: 4 }} />
              <Swiper
                breakpoints={{
                  [theme.breakpoints.values.sm]: {
                    slidesPerView: Math.min(posts.length, 2.1),
                    spaceBetween: 20
                  },
                  [theme.breakpoints.values.md]: {
                    slidesPerView: Math.min(posts.length, 3.1),
                    spaceBetween: 20
                  }
                }}
                modules={[Navigation, Pagination]}
                onBeforeInit={swiper => {
                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;
                }}
                slidesPerView={Math.min(posts.length, 1.1)}
                spaceBetween={20}
                style={{ "--swiper-pagination-color": "#fff" }}
              >
                {posts.map((post, index) => (
                  <SwiperSlide key={index} onClick={() => postOnClick(post)} style={{ cursor: "pointer", "--swiper-pagination-color": "#fff" }}>
                    {is.plainObject(post.featuredMedia.sourceUrl) ? (
                      <Box
                        sx={{
                          backgroundImage: `url(${
                            post.featuredMedia.sourceUrl.mediumLarge ?? post.featuredMedia.sourceUrl.large ?? post.featuredMedia.sourceUrl.full
                          })`,
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: 400
                        }}
                      />
                    ) : (
                      <ImagePlaceholder size={200} sx={{ height: 400 }} />
                    )}
                    <Box sx={{ background: theme.palette.background.paperAlt, display: { xs: "block", sm: "block" }, p: 2 }}>
                      <Typography component="div" variant="body2" sx={{ color: theme.palette.primary.main, textTransform: "uppercase" }}>
                        {post.title}
                      </Typography>
                      <Typography component="div" variant="body1">
                        {post.excerpt.plain}
                      </Typography>
                    </Box>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Container>
          </Paper>
          <Popup open={popupOpen} onClose={popupOnClose}>
            {is.plainObject(currentPost) && (
              <>
                <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
                  {currentPost.title}
                </Typography>
                {currentPost.content.html}
              </>
            )}
          </Popup>
        </>
      )}
    </>
  );
};

export default WhoWeAre;
